import React from "react";
import Typography from "@mui/material/Typography";

const BasicBox = ({ price, onChange }) => {
  return (
    <div className={"package-box"}>
      <h4>&nbsp;</h4>
      <a onClick={() => onChange("BASIC")}>
        <div className="content">
          <h5>Basic</h5>
          <div className="price">${price}</div>
          <Typography style={{color: "#7B848D",
            fontFamily: "MontserratRegular",
            fontSize: "0.7em", lineHeight: "20px", marginBottom: "0px"}}>+ USPTO fees</Typography>
          <div className="getstarted-btn" >Choose package</div>
        </div>
      </a>
    </div>
  );
};

export default BasicBox;
